import { render, staticRenderFns } from "./UIModal.vue?vue&type=template&id=067f5aa6&scoped=true"
import script from "./UIModal.vue?vue&type=script&lang=js"
export * from "./UIModal.vue?vue&type=script&lang=js"
import style0 from "./UIModal.vue?vue&type=style&index=0&id=067f5aa6&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067f5aa6",
  null
  
)

export default component.exports